import { BehaviorSubject } from 'rxjs';

// 1. Estado de botón deshabilitado
const disabledBtnTurn$ = new BehaviorSubject(false);
export const getDisabledBtnTurn = () => disabledBtnTurn$.asObservable();
export const setDisabledBtnTurn = (value) => disabledBtnTurn$.next(value);

// 2. Arreglo de IDs deshabilitados (recuperado de localStorage)
const initialDisabledIds = JSON.parse(localStorage.getItem('heavy-idArrDisabled') || '[]');
const idArrDisabled$ = new BehaviorSubject(initialDisabledIds);
export const getIdArrDisabled = () => idArrDisabled$.asObservable();

export const addIdArrDisabled = (id) => {
  const current = idArrDisabled$.value;
  if (!current.includes(id)) {
    const updated = [...current, id];
    localStorage.setItem('heavy-idArrDisabled', JSON.stringify(updated));
    idArrDisabled$.next(updated);
  }
};

// 3. Estado de primer ítem finalizado (recuperado de localStorage)
const initialFirstItemDone = JSON.parse(localStorage.getItem('heavy-isFirstItemDone') || 'false');
const isFirstItemDone$ = new BehaviorSubject(initialFirstItemDone);
export const firstItemService = {
  isFirstItemDone$: isFirstItemDone$.asObservable(),
  setIsFirstItemDone: (value) => {
    localStorage.setItem('heavy-isFirstItemDone', JSON.stringify(value));
    isFirstItemDone$.next(value);
  }
};

// 4. Validación de AWB guardada en localStorage
export const setValidateAwb = (value) => {
  localStorage.setItem('heavy-awbValue', value || '');
  const isNext = !(value === "" || value === "139-");
  localStorage.setItem('heavy-awbNext', JSON.stringify(isNext));
};

export const validateAwb = async () => {
  const awbValue = localStorage.getItem('heavy-awbValue') || '';
  const awbNext = JSON.parse(localStorage.getItem('heavy-awbNext') || 'false');

  if (!awbNext) {
    if (awbValue === "" || awbValue === "139-") {
      return {
        status: false,
        message: 'Todos los embarques deben tener un número de guía antes de continuar.'
      };
    }
  }

  return { status: true, message: "Coninue with the validation" };
};

// 5. Turn ID guardado en localStorage
export const setTunrId = (id) => {
  localStorage.setItem('heavy-turn_id', id || '');
};

export const getTurnId = async () => {
  return localStorage.getItem('heavy-turn_id') || '';
};

// 6. Alerta de finalización
export const finishTurnAlert = async (data) => {
  const currentDisabled = idArrDisabled$.value;
  const allDisabled = data.every(item => currentDisabled.includes(item.id));
  return allDisabled;
};

// 7. Reiniciar estado (Limpia memoria y localStorage al cambiar/finalizar turno)
export const resetTurnState = () => {
  disabledBtnTurn$.next(false);
  idArrDisabled$.next([]);
  firstItemService.setIsFirstItemDone(false);

  localStorage.removeItem('heavy-idArrDisabled');
  localStorage.removeItem('heavy-isFirstItemDone');
  localStorage.removeItem('heavy-awbValue');
  localStorage.removeItem('heavy-awbNext');
  localStorage.removeItem('heavy-turn_id');
};